// extracted by mini-css-extract-plugin
export default {"dropDownAndAudio":"style_dropDownAndAudio__WirHL","cardParent":"style_cardParent__j3G37","responsive":"style_responsive__j7N9x","inResponsive":"style_inResponsive__yzKlw"};